import type { IFormController } from "angular";
import { forEach, module } from "angular";
import { forOwn } from "lodash";

import type { IValidationService } from "./IValidationService";

export class ValidationService implements IValidationService {
    public static $inject = ["$translate", "aaNotify"];

    private static readonly aaNotifyToastHandles: any[] = [];

    constructor(private readonly $translate: angular.translate.ITranslateService, private readonly aaNotify: any) {}

    public showErrors(validationErrors: any, forms: any) {
        forEach(validationErrors, (errors: any, key: string) => {
            forEach(errors, (errorMessage: string) => {
                try {
                    // Below regex will match:
                    //  "Validation.Key: Friendly error message"
                    //   Example: "Validation.IsRequired: Name is required""
                    //  "Validation.Key,ConstraintVariable: Friendly error message"
                    //   Example: "Validation.MinLength,6: Password should be at least 6 long"
                    // eslint-disable-next-line @typescript-eslint/prefer-regexp-exec
                    const errorTemplateMatch = errorMessage.match(/^([A-Z][\S]*?(?:\.\S+?))(?:,(.*?))?:.*$/);

                    if (!errorTemplateMatch || errorTemplateMatch.length < 2) {
                        // eslint-disable-next-line
                        console.warn(
                            'ValidationMessage does not conform to "Prefix.Key: Detailed technical error" ' +
                                "and will therefore not be presented to user",
                            errorMessage,
                        );
                        return;
                    }

                    const errorTemplate = errorTemplateMatch[1];
                    const constraint = errorTemplateMatch.length >= 3 ? errorTemplateMatch[2] : undefined;

                    if (key === "") {
                        const toastHandle = this.aaNotify.danger(this.$translate.instant(errorTemplate));
                        ValidationService.aaNotifyToastHandles.push(toastHandle);
                    } else {
                        let foundKeyInSomeForm = false;
                        forEach(forms, (form: any) => {
                            if (form[key]) {
                                const internalDomElement = form[key].$$element;

                                let label = $(`label[for="${internalDomElement.attr("id") as string}"]`);

                                if (!label.length) {
                                    label = $(internalDomElement).parents("label");
                                }

                                if (label.length) {
                                    const valTemplate =
                                        `{{'${errorTemplate}' | translate : ` +
                                        `{propertyName: '${label.text()}', constraint: '${constraint || ""}'} }}`;

                                    form.$aaFormExtensions.$addValidationError(valTemplate, key);
                                    foundKeyInSomeForm = true;
                                }
                            }
                        });
                        if (!foundKeyInSomeForm) {
                            // eslint-disable-next-line
                            console.warn("Cannot find validationError key in form!", errorTemplate);
                        }
                    }
                } catch (e) {
                    // Swallow error
                    // eslint-disable-next-line
                    console.warn("Error translating validation error", e);
                }
            });
        });
    }

    public hideAllErrors() {
        if (!ValidationService.aaNotifyToastHandles.length) {
            return;
        }

        ValidationService.aaNotifyToastHandles.forEach((handle) => {
            this.aaNotify.remove(handle);
        });
        ValidationService.aaNotifyToastHandles.length = 0;
    }

    public validateForm(form: IFormController) {
        forOwn(form, (control: any, name: string) => {
            if (typeof name === "string" && name.startsWith("$")) {
                control.$setTouched();
                control.$validate();
            }
        });
    }
}

module("mmServices").service("irValidationService", ValidationService);
